import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { useClientId } from '../../../_hooks/useClientId';

export const FETCH_PERSONAL_INFO_ENDPOINT = '/Consumer/PersonalInfoStep';

interface UserDTO {
  FirstName: string;
  LastName: string;
  Dob: string | null;
}

export enum DependentType {
  Child,
  Parent,
  GrandParent,
  Spouse,
  Joint,
  Grandchild,
  OtherDependent,
  Charity,
  OtherBeneficiary,
}

export enum FilingStatus {
  Individual,
  HeadOfHousehold,
  MarriedFilingJointly,
  MarriedFilingSeparate,
}

interface DependentDTO {
  Id: string;
  FirstName: string;
  Dob: string | null;
  Type: DependentType;
  IsDependent: boolean | null;
}

export interface PersonalInfoDTO {
  Principal: UserDTO;
  IsCanadian: boolean;
  Partner: UserDTO | null;
  Taxes: {
    FilingState: number;
    FilingStatus: number;
  };
  FilingStateOptions: {
    label: string;
    value: number;
    IsInsideUS: boolean;
    EffectiveTaxRate: number;
    ExclusionAmount: number;
  }[];
  FilingStatusOptions: {
    label: string;
    value: FilingStatus;
  }[];
  Dependents: DependentDTO[];
  ShowPrincipalSsIncomeWarning: boolean;
  ShowSpouseSsIncomeWarning: boolean;
}

interface FetchPersonalInfoParams {
  clientId: number;
}

export const fetchPersonalInfo = async ({
  clientId,
}: FetchPersonalInfoParams): Promise<PersonalInfoDTO> => {
  return authFetch(urlWithParams(FETCH_PERSONAL_INFO_ENDPOINT, { clientId }));
};

interface PersonalInfoQueryParams {
  enabled?: boolean;
}

export const usePersonalInfoQuery = ({ enabled }: PersonalInfoQueryParams) => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.personalInfo(clientId),

    () => fetchPersonalInfo({ clientId }),

    {
      cacheTime: 0,
      enabled,
    },
  );
};
